import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";

import {client} from "@/app/api/client";
import {AppConfiguration} from "@/appConfiguration";
import {IResponse, TRootState} from "@/store";

interface IFeatureSet {
  enabled: string[];
}

export const GIFT_COPY_FEATURE_FLAG = "ai_gift_copy";

export const fetchFeatureFlags = createAsyncThunk(
  "features/fetchFeatureFlags",
  async (_, {getState}): Promise<IFeatureSet> => {
    const token = (getState() as TRootState).auth.token;
    const url = `${AppConfiguration.apiBaseUrl}/api/v2/features`;

    const response = await client.get<IResponse<IFeatureSet>>(url, {token});

    return response.data.data;
  }
);

interface IFeatureFlags {
  flags: string[];
  loading: boolean;
  error?: string;
}

const initialState: IFeatureFlags = {
  flags: [],
  loading: false,
  error: undefined,
};

const featuresSlice = createSlice({
  name: "features",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchFeatureFlags.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchFeatureFlags.fulfilled, (state, action) => {
        state.flags = action.payload.enabled;
        state.loading = false;
      })
      .addCase(fetchFeatureFlags.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const isFeatureEnabled = (state: TRootState, flagName: string) => state.features.flags.includes(flagName);

export default featuresSlice.reducer;
